export enum AutoConnectType {
  RENEW = 'renew',
  LINK = 'link',
}
